import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import LiveDecisionDemoPage from '@/pages/LiveDecisionDemoPage';
import ConsistencyReviewPage from '@/pages/ConsistencyReviewPage';

export default function DemoStudioModule() {
  const tabs = [
    { id: 'live', label: 'Live Decision', content: <LiveDecisionDemoPage /> },
    { id: 'consistency', label: 'Consistency Review', content: <ConsistencyReviewPage /> },
  ];
  return (
    <ModuleShell title="Demo Studio" subtitle="Bring-your-own-submission — live decisions and underwriting consistency reviews for prospects" tabs={tabs} />
  );
}
